/**
 * _generated - DEV0030 표준화면 빌더가 만든 라우트(기계 소유 레인).
 * 손으로 편집하지 않는다 - _generated.manifest.json 이 SSOT 이고 vite 플러그인이 통째 재렌더한다. 채택 시 routes/{domain}.js 로 수동 승격.
 */
const routes = [];

export default routes;
